import request from '@/utils/request'

export function updateCacheClearCfg(data) {
  return request({
    url: 'api/v1/clear-cache-apply/updateList',
    method: 'post',
    data: data
  })
}

export function getCacheClearList(data) {
  return request({
    url: 'api/v1/clear-cache-apply/getList',
    method: 'post',
    data: data
  })
}

export function getCacheClearLast(data) {
  return request({
    url: 'api/v1/clear-cache-apply/getLast',
    method: 'post',
    data: data
  })
}

export function delCacheClearCfg(data) {
  return request({
    url: 'api/v1/clear-cache-apply/delCfg',
    method: 'delete',
    data: data
  })
}

